import { useColumns } from "app/hooks/useColumns";
import { useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";

const useGetFormValueFromDependencyField = (dependencyFieldId: string) => {
    const { data: columns } = useColumns();
    const { control } = useFormContext();

    const column = useMemo(() => {
        if (!dependencyFieldId || !columns) {
            return {};
        }
        return {
            ...columns.find((c) => c.id === dependencyFieldId)
        }
    }, [columns, dependencyFieldId]);

    const watchedValue = useWatch({
        control,
        name: column.name || "__missing_dependency__",
    });

    return {
        column,
        fieldValue: column.name ? watchedValue : undefined,
    };
};

export default useGetFormValueFromDependencyField;
